import { createAction, props } from '@ngrx/store';
import { ExchangeFare } from 'src/app/core/models/voluntary-change.model';
import { ContractError } from 'src/app/core/models/models';
import {
  PenaltyOverride,
  FixedChargeOverride,
  IEditValuesModal
} from 'src/app/core/models/cancellation-overrides.model';

export const SavePenalties = createAction(
  '[Voluntary Change Page] Save Penalties',
  props<{ valuesModal: IEditValuesModal }>()
);

export const SaveFixedCharges = createAction(
  '[Voluntary Change Page] Save Fixed Charges',
  props<{ fixedChargeOverrides: FixedChargeOverride[] }>()
);

export const ChangeCostMode = createAction(
  '[Voluntary Change Page] Change Cost Mode',
  props<{ isNoDifferenceValue: boolean }>()
);

export const SavePenaltiesNewFlow = createAction(
  '[New Flow Change Page] Save Penalties',
  props<{ penalties: PenaltyOverride[] }>()
);

export const SaveFixedChargesNewFlow = createAction(
  '[New Flow Change Page] Save Fixed Charges',
  props<{ fixedChargeOverrides: FixedChargeOverride[] }>()
);

export const ChangeCostModeNewFlow = createAction(
  '[New Flow Change Page] Change Cost Mode',
  props<{ isNoDifferenceValue: boolean }>()
);

export const ExchangeOverrideSuccess = createAction(
  '[Voluntary Change Page] Exchange Override Success',
  props<{ exchangeFare: ExchangeFare }>()
);

export const ExchangeOverrideFail = createAction(
  '[Voluntary Change Page] Exchange Override Fail',
  props<{ error: ContractError }>()
);

export const ExchangeOverrideNewFlowSuccess = createAction(
  '[New Flow Change Page] Exchange Override Success',
  props<{ exchangeFare: ExchangeFare }>()
);

export const ExchangeOverrideNewFlowFail = createAction(
  '[NewFlow Change Page] Exchange Override Fail',
  props<{ error: ContractError }>()
);
